import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ChartPoint } from './api';

const CHART_HEIGHT = 400;
const LINE_COLOR = '#8884d8';

type Props = {
  data: ChartPoint[];
  /** Y axis caption, also the tooltip series name. */
  label: string;
};

export const MetrikaChart = ({ data, label }: Props) => (
  <div style={{ width: '100%', height: CHART_HEIGHT }}>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" height={70} label={{ value: 'Даты', position: 'insideBottom' }} />
        <YAxis
          width={140}
          allowDecimals={false}
          domain={[0, 'auto']}
          label={{ value: label, angle: -90, position: 'insideLeft' }}
        />
        <Tooltip formatter={(value) => [value, 'Всего']} />
        <Line type="monotone" dataKey="data" stroke={LINE_COLOR} />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
